import React, { useState } from "react";
import AdminTabelHeader from "../../../components/layout/header/AdminTabelHeader";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import { BASEURL } from "../../../../utils/BaseUrl";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import TraingleLoading from "../../../../common/Loading/TraingleLoading";
import ManditoryStar from "../../../templates/ManditoryStar";

const AdminTimelineform = () => {
  const [timelineData, setTimelineData] = useState({
    date: "",
    archievement: "",
  });
  const checkSumbit = () => {
    let status = true;

    if (
      timelineData.date !== ''&&
      timelineData.archievement !==""
     
    ) {
      status = false;
    } else {
      status = true;
    }
    return status;
  };

  const { id } = useParams();
  const navigate = useNavigate();

  const { data,isLoading } = useQuery({
    queryKey: "getsingleFaq",
    queryFn: () =>
      axios.get(`${BASEURL}milestones/${id}`).then((res) => {
        return res?.data;
      }),
    onSuccess: (response) => {
      setTimelineData({
        date: response.milestone.date,
        archievement: response.milestone.archievement,
      });
    },
  });
  

  const handleChange = (e) => {
    let newdata = { ...timelineData };
    newdata[e.target.name] = e.target.value;
    setTimelineData(newdata);
  };

  const mutation = useMutation({
    mutationFn: (values) => {
      return axios.post(`${BASEURL}milestones`, values);
    },
    onSuccess: () => {
      Swal.fire({
        title: "Created successfully",
        icon: "success",
        draggable: false,
        // confirmButtonColor:"#fcd70c",
        customClass: {
          confirmButton: "custom-confirm-button", // Add a custom class for styling
        },
      }).then(() => {
        navigate("/admin/about/timeline");
      });
    },
  });

  const editMutation = useMutation({
    mutationFn: (values) => {
      return axios.put(`${BASEURL}milestones/${id}`, values);
    },
    onSuccess: () => {
      Swal.fire({
        title: "Updated successfully",
        icon: "success",
        draggable: false,
        // confirmButtonColor:"#fcd70c",
        customClass: {
          confirmButton: "custom-confirm-button", // Add a custom class for styling
        },
      }).then(() => {
        navigate("/admin/about/timeline");
      });
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const values = {
      date: timelineData.date,
      archievement: timelineData.archievement,
    };
    mutation.mutate(values);
  };

  const handleUpdate = (e) => {
    e.preventDefault();

    const values = {
      date: timelineData.date,
      archievement: timelineData.archievement,
    };
    editMutation.mutate(values);
  };
  return (
    <div>
      {((id &&  isLoading) || mutation.isLoading || editMutation.isLoading) && <TraingleLoading />}

      <AdminTabelHeader title={id?"Edit Timeline":"Add Timeline"} btnStatus={false} />
      <div className="p-4">
        <div className="grid grid-cols-1 gap-4">
          <div>
           
          <ManditoryStar title={"achievement Year"} />

            <input
              name="date"
              // className={`input`}
              className={`input ${
                timelineData.date !== ""
                  ? "input-success"
                  // : newsCardData.heading === ""
                  // ? "input-error"
                  : ""
              }`}
              type="text"
              value={timelineData.date}
            
              onChange={(e) => handleChange(e)}
            />
          </div>
          <div>
           
          <ManditoryStar title={"achievement"} />

            <textarea
              name="archievement"
              // className={`textarea `}
              className={`textarea ${
                timelineData.archievement !== ""
                  ? "input-success"
                  // : newsCardData.heading === ""
                  // ? "input-error"
                  : ""
              }`}
              value={timelineData.archievement}
              onChange={(e) => handleChange(e)}
            />
          </div>
        </div>
        <div className="flex justify-end my-4 ">
        <button
            onClick={() => navigate(-1)}
            // disabled={checkSubmit()}
            className={"formSubmit mr-8 cursor-pointer "}
          >
            Cancel
          </button>
          <button

            onClick={id ? (e) => handleUpdate(e) : (e) => handleSubmit(e)}
            // className={`formSubmit`}
            className={`formSubmit  ${
              checkSumbit() ? "cursor-not-allowed " : "cursor-pointer"
            } `}
          >
            {id ? "Update" : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminTimelineform;
